import { IssuePlacementPin, PlacementType } from "@adsk/acc-issues-types";
import {
  IssuePlacementPinUpsert,
  SerializedContext,
} from "../types/PlacementViewer";
import { isNumber, isString } from "lodash";
import { SheetViewable } from "@adsk/feature-markups";

export const getPlacementType = (
  pin: IssuePlacementPin | IssuePlacementPinUpsert | undefined,
  context: SerializedContext
): PlacementType => {
  if (!pin) {
    return PlacementType.None;
  }

  const isSheet = isSheetContext(context);
  const is3D = "z" in pin.position ? isNumber(pin.position.z) : false;

  if (isSheet) {
    return PlacementType.SheetView;
  } else if (is3D) {
    return PlacementType.ThreeDFileView;
  } else {
    return PlacementType.TwoDFileView;
  }
};

export const isSheetContext = (context: SerializedContext): boolean => {
  return isString((context.currentViewable as SheetViewable)?.sheetUid);
};
